import React, { useState, useEffect } from "react";

function SignIn() {
  // Step 1: Set up state to hold the fetched words
  const [words, setWords] = useState([]);

  // Step 2: Use the useEffect hook to fetch words when the component mounts
  useEffect(() => {
    async function fetchWords() {
      try {
        const response = await fetch('https://<your-cloud-function-url>/getWords');
        const words = await response.json();
        setWords(words); // Update the state with the fetched words
      } catch (error) {
        console.error('Error fetching words:', error);
      }
    }

    fetchWords();
  }, []); // Empty array means this effect runs only once when the component mounts

  // Step 3: Render the words in the JSX
  return (
    <div className="positive-words-container">
      <h1>Random Positive Words</h1>
      <div id="words-container">
        {words.length > 0 ? (
          words.map((word, index) => (
            <p key={index}>{word}</p>
          ))
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
  );
}

export default SignIn;




